import { create } from "zustand";

export const useStore = create(set => ({
  replacementBookings: [],

  setReplacementBookings: replacementBookings => set({ replacementBookings })
}));
